import styled from "styled-components";

const StyledUserPointsModal = styled.div`
  padding: 0 0 20px;
  .title {
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    color: #48465b;
    margin: 20px 0;
    text-align: center;
  }
`;

export default StyledUserPointsModal;
